// test2076
(2076 && 0);
